'use strict';

var _Observable = require('rxjs/Observable');

var _utils = require('../utils');

_Observable.Observable.prototype.mapResponse = _utils.mapResponse;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@driftt/dapper/lib/rx/add/mapResponse.js
// module id = QHw5
// module chunks = 88